// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/daily_workload_level.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/daily_workload_level.proto.
 */
export const file_studyo_today_planners_v1_resources_daily_workload_level = /*@__PURE__*/
  fileDesc("Cj1zdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2RhaWx5X3dvcmtsb2FkX2xldmVsLnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzKpgBChJEYWlseVdvcmtsb2FkTGV2ZWwSJAogREFJTFlfV09SS0xPQURfTEVWRUxfVU5TUEVDSUZJRUQQABIcChhEQUlMWV9XT1JLTE9BRF9MRVZFTF9MT1cQARIfChtEQUlMWV9XT1JLTE9BRF9MRVZFTF9NRURJVU0QAhIdChlEQUlMWV9XT1JLTE9BRF9MRVZFTF9ISUdIEANCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.planners.v1.resources.DailyWorkloadLevel.
 */
export const DailyWorkloadLevelSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_daily_workload_level, 0);

/**
 * Levels of workload for a given day.
 *
 * @generated from enum studyo.today.planners.v1.resources.DailyWorkloadLevel
 */
export const DailyWorkloadLevel = /*@__PURE__*/
  tsEnum(DailyWorkloadLevelSchema);

